import {Injectable} from '@angular/core';
import {ISessionInject} from '../models/session-inject';
import {AuthenticateService} from './authenticate.service';

@Injectable()
export class HttpSessionServiceLS implements ISessionInject {

  public token_name = 'WWWToken';

  public getHeaderCaption(): string {
    return this.token_name;
  }

  public setSessionID(value: string): void {

  }

  public getSessionID(): string {
    return AuthenticateService.session_id;
  }

}
